import React, { useState } from 'react';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { getAuth } from 'firebase/auth';
import { initializeApp } from 'firebase/app';
import { firebaseConfig } from '../firebaseConfig';

function VerifyCodePage() {
  const [code, setCode] = useState('');
  const [methodDocId, setMethodDocId] = useState('');
  const [status, setStatus] = useState('idle');
  const [message, setMessage] = useState('');

  const app = initializeApp(firebaseConfig);
  const auth = getAuth(app);
  const functions = getFunctions(app);

  const sendCode = async () => {
    if (!methodDocId) {
      setMessage('Missing method ID');
      return;
    }

    setStatus('sending');
    setMessage('Sending verification code...');

    try {
      const sendVerificationCode = httpsCallable(functions, 'sendVerificationCode');
      await sendVerificationCode({ methodDocId });
      
      setStatus('sent');
      setMessage('Verification code sent! Enter the code below.');
    } catch (error) {
      console.error('Error sending code:', error);
      setStatus('error');
      setMessage(error.message || 'Failed to send code');
    }
  };

  const verifyCode = async () => {
    if (!methodDocId || !code) {
      setMessage('Please enter the code');
      return;
    }

    setStatus('verifying');
    setMessage('Verifying...');

    try {
      const verifyCodeFn = httpsCallable(functions, 'verifyCode');
      await verifyCodeFn({ methodDocId, code });
      
      setStatus('success');
      setMessage('Verification successful!');
      
      setTimeout(() => {
        window.location.href = 'fodyfee://verified';
      }, 1500);
    } catch (error) {
      console.error('Error verifying code:', error);
      setStatus('error');
      setMessage(error.message || 'Invalid or expired code');
    }
  };

  return (
    <div style={{
      fontFamily: 'Arial, sans-serif',
      maxWidth: '400px',
      margin: '50px auto',
      padding: '24px',
      textAlign: 'center',
    }}>
      <h1 style={{ color: '#FF5722', marginBottom: '24px' }}>FodyFee Verification</h1>
      
      {status === 'idle' && (
        <div>
          <input
            type="text"
            placeholder="Method Doc ID"
            value={methodDocId}
            onChange={(e) => setMethodDocId(e.target.value)}
            style={{
              width: '100%',
              padding: '12px',
              marginBottom: '12px',
              borderRadius: '8px',
              border: '1px solid #ccc',
            }}
          />
          <button
            onClick={sendCode}
            style={{
              width: '100%',
              padding: '12px',
              background: '#FF5722',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '16px',
            }}
          >
            Send Code
          </button>
        </div>
      )}

      {status === 'sent' && (
        <div>
          <input
            type="text"
            placeholder="Enter 6-digit code"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            maxLength={6}
            style={{
              width: '100%',
              padding: '12px',
              marginBottom: '12px',
              borderRadius: '8px',
              border: '1px solid #ccc',
              fontSize: '24px',
              textAlign: 'center',
              letterSpacing: '8px',
            }}
          />
          <button
            onClick={verifyCode}
            style={{
              width: '100%',
              padding: '12px',
              background: '#FF5722',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '16px',
            }}
          >
            Verify
          </button>
        </div>
      )}

      {status === 'success' && (
        <div style={{ color: 'green' }}>
          <svg width="64" height="64" viewBox="0 0 24 24" fill="green">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
          </svg>
          <p>{message}</p>
        </div>
      )}

      {(status === 'error' || status === 'sent') && (
        <p style={{ color: status === 'error' ? 'red' : '#666', marginTop: '16px' }}>
          {message}
        </p>
      )}

      {status === 'sending' && (
        <p style={{ color: '#666' }}>Sending code...</p>
      )}
    </div>
  );
}

export default VerifyCodePage;